import { createSlice } from '@reduxjs/toolkit';

import { createPreProductionOrder  } from '../../apis';

export const PreProductionSlice = createSlice({

    name: 'preProduction',
    initialState: {
        isLoading: false,
        orderCreatedSuccess: false,
        error : ''
    },

    reducers: {
        clearError: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value
            }
        }
    },

    extraReducers: (builder) => {
       
        builder.addCase(createPreProductionOrder.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(createPreProductionOrder.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.orderCreatedSuccess = true;
        })
        builder.addCase(createPreProductionOrder.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
    }
})

export const { clearError } = PreProductionSlice.actions
export default PreProductionSlice.reducer